import React, { useMemo } from 'react'
import { ChatMessage, ChatMessagePart } from 'types/Chat'
import { Maybe } from 'types/Maybe'
import { getChatMessageParts } from 'utils/chatMessageParts'
import { ChatMarkdown } from './ChatMarkdown'

type ChatPartRenderers = {
  [Type in ChatMessagePart['type']]: React.FC<{
    part: Extract<ChatMessagePart, { type: Type }>
  }>
}

const ChatTextPartRenderer: ChatPartRenderers['text'] = ({ part }) => (
  <ChatMarkdown content={part.text} />
)

const PART_RENDERERS: ChatPartRenderers = {
  text: ChatTextPartRenderer,
}

interface ChatMessagePartsProps {
  message: ChatMessage
}

const ChatMessageParts: React.FC<ChatMessagePartsProps> = ({ message }) => {
  const parts = useMemo(() => getChatMessageParts(message), [message])

  return (
    <>
      {parts.map((part, index) => {
        // TypeScript does not correlate the key with the part once the union grows.
        const Renderer = PART_RENDERERS[part.type] as Maybe<React.FC<{ part: ChatMessagePart }>>

        // Parts are positional and only ever appended.
        // eslint-disable-next-line react/no-array-index-key
        return Renderer ? <Renderer key={index} part={part} /> : null
      })}
    </>
  )
}

export { ChatMessageParts }
